<template>
  <div class="container">
    <content-header :data="[{text:'商品列表', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
          <router-link to="/product/new">
            <el-button type="primary" icon="plus">添加</el-button>
          </router-link>
        </div>
        <div class="search-entry">
          <el-select v-model="brand_id" clearable value-key="id" placeholder="请选择品牌" @change="searchHandle">
            <el-option
              v-for="item in brandIds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="请输入查询关键字"
              @keyup.enter.native="searchHandle"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            type="index"
            width="80">
          </el-table-column>
          <el-table-column
            prop="name"
            label="商品名称"
            width="150">
          </el-table-column>
          <el-table-column
            prop="manufacture"
            label="品牌"
            width="150">
          </el-table-column>
          <el-table-column
            prop="description"
            label="描述">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="200">
            <template slot-scope="scope">
              <!--el-button @click="sampleRowClick(scope.row)" type="text" size="small" >查看</el-button-->
              <el-button @click="initEditHandle(scope)" type="text" size="small" >修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > curSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="curSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- dialog -->
      <div class="view-wrap">
        <el-dialog title="样品详情" :visible.sync="isProductView">
          <sample-view :data="selectedSample"></sample-view>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isProductView = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import ProductModel from 'models/product'
  import BrandModel from 'models/brand'
  // import BrandModel from 'models/brand'
  import { mapState } from 'vuex'
  import ProductView from 'components/ProductView'

  export default {
    components: {
      ProductView
    },
    data () {
      return {
        domainPic: constants.basic.domain_pic,
        keywords: '',
        tableData: [],
        formLabelWidth: '80px',
        curPage: 1,
        curSize: 10,
        total: 0,
        //
        isProductView: false,
        selectedSample: {},
        //
        brand_id: '',
        brandIds: []
      }
    },
    created () {
      this.getObjList()
      BrandModel.find().then(res => {
        this.brandIds = res.rows
      })
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.info
      }),
    },
    methods: {
      pageSizeChange (size) {
        this.curSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.curSize
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        ProductModel.find(_opts).then(res => {
          this.tableData = res.rows
          this.total = res.total
        })
      },
      initEditHandle (item) {
        this.$router.push({
          name: 'product.new',
          query: { id: item.row.id }
        })
      },
      deleteHandle (item) {
        this.$confirm('确认删除 ' + item.row.name + '?')
          .then(_ => {
            ProductModel.delete({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(_ => {
              this.$message({ message: '删除失败', type: 'error' })
            })
          })
          .catch(_ => {})
      },
      searchHandle () {
        this.getObjList({keywords: this.keywords, brandId: this.brand_id})
      },
      sampleRowClick (row, event, column) {
        ProductModel.get({id: row.id}).then(res => {
          this.selectedSample = res
          this.isProductView = true
        })
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 20px
      .search-btn
        display: inline-block
        vertical-align: top
      .action-btn
        display: inline-block
        vertical-align: top
        float: right
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
</style>



// WEBPACK FOOTER //
// src/views/Product.vue